import React from 'react';
import { useTranslation } from 'react-i18next';

export default function AuditConfigBanner({ config }) {
  const { t } = useTranslation();
  if (!config) return null;

  const messages = [];
  if (config.write_target === 'cloud' && config.writes_enabled) {
    messages.push({ tone: 'error', text: t('traceability:banner.cloudWrites') });
  }
  if (config.app_cloud_uri && config.app_write_allowed) {
    messages.push({ tone: 'error', text: t('traceability:banner.appCloudWrites') });
  } else if (config.app_cloud_uri) {
    messages.push({ tone: 'info', text: t('traceability:banner.appCloudReadOnly') });
  }
  if (!config.writes_enabled) {
    messages.push({ tone: 'warn', text: t('traceability:banner.writesDisabled') });
  }
  if (!config.read_configured) {
    messages.push({ tone: 'error', text: t('traceability:banner.readNotConfigured') });
  }
  if (config.redacted) {
    messages.push({ tone: 'info', text: t('traceability:banner.redacted') });
  }
  // Always show the target hint so the user can verify at a glance.
  if (config.write_target) {
    const isLocal = config.write_target === 'local';
    messages.push({
      tone: isLocal ? 'info' : (config.writes_enabled ? 'error' : 'info'),
      text: t('traceability:banner.writeTarget', { target: config.write_target }),
    });
  }
  if (messages.length === 0) return null;

  return (
    <div className="mb-4 space-y-2">
      {messages.map((m, i) => (
        <div
          key={i}
          className={`px-4 py-2 text-sm rounded border ${toneClass(m.tone)}`}
        >
          {m.text}
        </div>
      ))}
    </div>
  );
}

function toneClass(tone) {
  if (tone === 'error') return 'bg-red-50 text-red-800 border-red-300 dark:bg-red-950/60 dark:text-red-200 dark:border-red-800';
  if (tone === 'warn') return 'bg-accent/10 border-accent/40 text-accent-text';
  return 'bg-surface-raised border-border-strong text-ink-secondary';
}
